(() => {
  if (window.RiftReviewGrid) return;

  const oncePerElement = (element, key) => {
    if (!element) return false;
    const flag = `rift${key}`;
    if (element.dataset[flag] === '1') return false;
    element.dataset[flag] = '1';
    return true;
  };

  const observeOnce = (elements, { threshold = 0.1, rootMargin = '0px', onEnter }) => {
    if (!elements || !elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach((el) => onEnter(el));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          onEnter(entry.target);
          observer.unobserve(entry.target);
        }
      },
      { threshold, rootMargin }
    );

    elements.forEach((el) => observer.observe(el));
  };

  const ensureVideoSrc = (video) => {
    if (!video) return false;

    const src = video.dataset.riftVideoSrc;
    if (!src) return false;

    // Already loaded
    if (video.currentSrc || video.src) return true;

    video.src = src;
    try {
      video.load();
    } catch {
      // ignore
    }

    return true;
  };

  const initFadeIn = (root) => {
    const cards = Array.from(root.querySelectorAll('.testimonial-cards'));
    if (!cards.length) return;

    observeOnce(cards, {
      threshold: 0.1,
      onEnter: (card) => {
        if (!oncePerElement(card, 'TestimonialFadeIn')) return;
        card.classList.add('opacity-100', 'translate-y-0', 'fade-in');
        card.classList.remove('opacity-0', 'translate-y-20');
      }
    });
  };

  const initReels = (root) => {
    const cards = Array.from(root.querySelectorAll('.reel-card--sleep8-style'));
    if (!cards.length) return;

    const allVideos = Array.from(root.querySelectorAll('video.reel-video'));

    const pauseOthers = (currentVideo) => {
      for (const video of allVideos) {
        if (video === currentVideo) continue;
        try {
          video.pause();
        } catch {
          // ignore
        }

        const otherCard = video.closest('.reel-card--sleep8-style');
        if (!otherCard) continue;

        const otherButton = otherCard.querySelector('.reel-play-button');
        if (otherButton) otherButton.style.display = 'block';
      }
    };

    for (const card of cards) {
      if (!oncePerElement(card, 'ReelInit')) continue;

      const video = card.querySelector('video.reel-video');
      const button = card.querySelector('.reel-play-button');
      const cover = card.querySelector('.reel-cover-image');

      if (!video || !button) continue;

      try {
        video.pause();
      } catch {
        // ignore
      }

      // Reels without an uploaded cover used to stay completely unloaded until
      // click, leaving a black card. Load only when the card is near the
      // viewport, then seek just past zero so the paused video supplies a real
      // thumbnail without autoplaying or downloading every reel at page load.
      if (!cover) {
        video.preload = 'metadata';

        observeOnce([card], {
          threshold: 0,
          rootMargin: '400px 0px',
          onEnter: () => {
            video.muted = true;
            ensureVideoSrc(video);

            const showFirstFrame = () => {
              if (!Number.isFinite(video.duration) || video.duration <= 0) return;
              try {
                video.currentTime = Math.min(0.12, video.duration / 10);
              } catch {
                // The browser will still show its native first frame when available.
              }
            };

            if (video.readyState >= 1) showFirstFrame();
            else video.addEventListener('loadedmetadata', showFirstFrame, { once: true });
          }
        });
      }

      const playVideo = async () => {
        pauseOthers(video);

        ensureVideoSrc(video);
        if (cover) cover.classList.add('hidden');

        video.muted = false;

        try {
          await video.play();
          button.style.display = 'none';
        } catch {
          // If playback fails (e.g. browser policy), keep the button visible.
          button.style.display = 'block';
        }
      };

      button.addEventListener('click', playVideo);
      if (cover) cover.addEventListener('click', playVideo);

      video.addEventListener('click', () => {
        if (video.paused) {
          void playVideo();
        } else {
          try {
            video.pause();
          } catch {
            // ignore
          }
          button.style.display = 'block';
        }
      });
    }
  };

  const init = (root = document) => {
    const sections = Array.from(root.querySelectorAll('.wall-of-love-section'));
    if (!sections.length) return;

    for (const section of sections) {
      initFadeIn(section);
      initReels(section);
    }
  };

  window.RiftReviewGrid = { init };

  const run = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', (event) => {
    if (!event || !event.target) return;
    init(event.target);
  });
})();
